import React from "react";
import { Tag } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, MaskLines } from "./Reveal";

export const Offers = () => {
  const { t } = useLang();
  const o = t.offers;

  return (
    <section id="offers" data-testid="offers-section" className="relative py-24 sm:py-32">
      <div className="spot-glow w-[400px] h-[400px] bg-[#1E5631]/15 top-40 right-0" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-[#D4AF37] mb-6">
            {o.overline}
          </p>
        </Reveal>
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <h2 className="font-display font-medium tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-2xl text-white">
            <MaskLines lines={[o.title]} />
          </h2>
          <Reveal delay={0.15}>
            <p className="text-zinc-400 max-w-sm lg:text-right">{o.lead}</p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {o.cards.map((card, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div
                data-testid={`offer-card-${i}`}
                className="group h-full rounded-2xl border border-white/10 bg-[#0F1012] p-7 sm:p-8 hover:border-[#D4AF37]/50 hover-lift"
              >
                <span className="inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-[#D4AF37] border border-[#D4AF37]/30 rounded-full px-3 py-1.5">
                  <Tag size={11} /> {card.tag}
                </span>
                <h3 className="mt-6 font-display text-2xl font-semibold text-white group-hover:text-[#D4AF37] transition-colors">
                  {card.t}
                </h3>
                <p className="mt-3 text-zinc-400 leading-relaxed">{card.d}</p>
                <div className="mt-6 h-px w-full bg-white/10 group-hover:bg-[#D4AF37]/40 transition-colors" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
